module.exports = __webpack_public_path__ + "assets/poland.9f729178a43020fa35016039614dcddc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/flags/poland.png
// module id = 89
// module chunks = 0